// @flow
import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation CategoryEditMutation(
    $input: CategoryEditInput!
    ) {
        CategoryEdit(input: $input) {
            Category {
                id
            },
            error
        }
    }
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
    commitMutation(
        environment,
        {
            mutation,
            variables: {
                input: params,
            },
            onCompleted: (response) => {
                // console.log(response);
                if (response.error !== null) {
                    callback(response.error, response.CategoryEdit.Category.id);
                    return;
                }
                callback(null, response.CategoryEdit.Category.id);
            },
            onError: (error) => {
                console.log('error mutating');
                console.log(error);
                callback(error, null);
            },
        },
    );
}



// WEBPACK FOOTER //
// src/mutations/CategoryEditMutation.js